/**
 * Custom i18next language detector that safely handles localStorage errors
 * Replaces i18next-browser-languagedetector's localStorage caching
 */

import { safeStorage, I18N_STORAGE_KEY } from '@/lib/safe-storage';
import { SUPPORTED_LANGUAGES } from './languages';

const SafeLanguageDetector = {
  type: 'languageDetector' as const,

  init() {
    // No initialization needed
  },

  detect() {
    // Try to detect language in order: localStorage -> navigator
    const stored = safeStorage.getItem(I18N_STORAGE_KEY);
    if (stored) {
      return stored;
    }

    // Fallback to browser language
    if (typeof navigator !== 'undefined') {
      if (navigator.language) {
        return navigator.language;
      }
      if (navigator.languages && navigator.languages.length > 0) {
        return navigator.languages[0];
      }
    }

    return SUPPORTED_LANGUAGES[0].code; // Ultimate fallback
  },

  cacheUserLanguage(lng: string) {
    safeStorage.setItem(I18N_STORAGE_KEY, lng);
  },
};

export default SafeLanguageDetector;
